export const WEB_MEDIA_NOTICE = "Les médias ne sont pas disponibles sur le Web pour le moment.";

export function unsupportedMedia(): never {
  throw Object.assign(new Error(WEB_MEDIA_NOTICE), { code: "post/web-media-unsupported" });
}
